import React from 'react';
import { Image, Spinner, T } from '@colonist/ui';
import styles from './ShareImagePreview.module.scss';
/* Preview of the shareable game results image */ export const ShareImagePreview = (props)=>{
    switch(props.status){
        case 'idle':
        case 'loading':
            return /*#__PURE__*/ React.createElement("div", {
                className: styles.loadingContainer
            }, /*#__PURE__*/ React.createElement(Spinner, {
                className: styles.loading
            }));
        case 'error':
            return /*#__PURE__*/ React.createElement("div", {
                className: styles.errorContainer
            }, /*#__PURE__*/ React.createElement(T, {
                id: {
                    key: 'strings:game.endGame.shareImagePopup.failedToLoad'
                }
            }));
        case 'ready':
            return /*#__PURE__*/ React.createElement(Image, {
                className: styles.image,
                image: {
                    src: props.imageUrl,
                    alt: {
                        key: 'strings:game.endGame.shareImagePopup.title'
                    }
                }
            });
    }
};
